export default "__VITE_ASSET__Cnth_hak__"